import { render } from "./file.vue?vue&type=template&id=4bde5f1e"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/input-only/file.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4bde5f1e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4bde5f1e', __exports__)) {
    console.log('reload')
    api.reload('4bde5f1e', __exports__)
  }
  
  module.hot.accept("./file.vue?vue&type=template&id=4bde5f1e", () => {
    console.log('re-render')
    api.rerender('4bde5f1e', render)
  })

}


export default __exports__